<script lang="tsx">
import { defineComponent, type PropType, type VNodeChild } from 'vue'
import { QuestionCircleOutlined } from '@ant-design/icons-vue'
import { Tooltip } from 'ant-design-vue'
import { createNamespace, getSlot, isString } from '@bd/vue3-utils'
const [name, bem] = createNamespace('CommonHelp')
export default defineComponent({
  name,
  props: {
    text: {
      type: [String, Object, Array, Number, Boolean] as PropType<VNodeChild | JSX.Element | string>
    }
  },
  setup(props, { slots, attrs }) {
    const renderTitle = () => {
      if (isString(props.text)) {
        return <div v-html={props.text} />
      } else {
        return <>{props.text}</>
      }
    }
    return () => (
      <Tooltip placement='top' title={renderTitle()} {...attrs}>
        <span class={bem()}>{getSlot(slots) || <QuestionCircleOutlined />}</span>
      </Tooltip>
    )
  }
})
</script>

<style lang="less">
.common-help {
  padding: 0 5px;
  color: @gray !important;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    color: @primary-color !important;
  }
}
</style>
